import createLucideIcon from '../createLucideIcon';

const Landmark = createLucideIcon('LandmarkIcon', [
  ['line', { x1: '3', y1: '22', x2: '21', y2: '22', key: '1mkv49' }],
  ['line', { x1: '6', y1: '18', x2: '6', y2: '11', key: 'shpxqa' }],
  ['line', { x1: '10', y1: '18', x2: '10', y2: '11', key: '6quq76' }],
  ['line', { x1: '14', y1: '18', x2: '14', y2: '11', key: 'qxd7vm' }],
  ['line', { x1: '18', y1: '18', x2: '18', y2: '11', key: '1m478d' }],
  ['polygon', { points: '12 2 20 7 4 7', key: 'jkujk7' }],
]);

export default Landmark;
